import { mapGetters } from 'vuex';
import DisplayTime from '@/components/site/parts/DisplayTime.vue'
export const myItemValidity = {  
    data(){
        return{
            isLoading:true
        }
    },    
    components:{
        DisplayTime
    },
    computed:mapGetters({
        itemLists:'item/getItemsValidity'
    }),
    mounted(){
        this.getItemValidity();
    },
    methods:{
        async getItemValidity(){
           const formData = {               
                user_id:this.$store.getters.currentUser.id    
            }
            try {
                const response = await this.$store.dispatch("item/getItemValidity", formData)                
                this.isLoading = false;
                this.itemlists = response;   

            }catch(error){
                console.log(error);               
            }
        },
    }
}